/**
 * Remove spaces before and after the barcode input, Unicode characters, and control characters from a barcode
 * with failsave when barcode is not given (do not trust open api spec at the moment for 100%)
 *
 * FIXME: SPA-2557
 *
 */

export const cleanupBarcode = (barcode: string) => barcode?.replace(/[^\x20-\x7E]/g, '').trim()
